import { useState } from "react";

const ThemeToggle = () => {
  const [darkMode, setDarkMode] = useState(true);

  const toggleTheme = () => {
    setDarkMode(!darkMode);
    document.body.className = darkMode ? "light-mode" : "dark-mode";
  };

  return (
    <button onClick={toggleTheme} style={{ padding: "10px", margin: "20px" }}>
      {darkMode ? "Açık Mod" : "Karanlık Mod"}
    </button>
  );
};

export default ThemeToggle;
